export const globalTheme = {
  background: "#f2f4f8",
  primaryColor: "#595c97",
  secondaryColor: "#a1a1c2",
  activeMenu: "#0071e3",
  white: "#ffffff",
  border: "#e4e9f0",
  error: "#f44336",
  connecting: "#ffa500",
};
